export default function(value) {
    return Object.prototype.toString.call(value).replace(/^\[\w+\s(\w+)\]$/, '$1');
};


// WEBPACK FOOTER //
// ./src/components/shared/getValueType.js